export default class ColorItem {
	id = null;
	item_number = '';
	color_name = '';
	image_url = '';
	base_number = '';
	quantity_in_pack = '';

	constructor(item) {
		this.id = item.Id;
		this.item_number = item.ItemNumber;
		this.color_name = item.ColorName;
		this.image_url = item.ImageUrl;
		this.base_number = item.BaseItemNumber;
		this.quantity_in_pack = item.QtyInPack;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/ColorItem.js